import { RotateCcw } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { NativeSelect } from "@/components/Field";
import { useApp } from "@/context/AppContext";
import { thisYear, yearOptions } from "@/lib/format";

export const defaultFilters = () => ({ year: String(thisYear()) });

export function FilterBar({ value, onChange, extra = [], testid = "filters" }) {
  const ctx = useApp();
  const set = (k, v) => onChange({ ...value, [k]: v });
  const usingDates = value.start || value.end;
  return (
    <div className="no-print grid grid-cols-2 gap-3 rounded-xl border border-slate-200 bg-white p-4 md:grid-cols-4 lg:grid-cols-6" data-testid={testid}>
      <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
        Year
        <NativeSelect value={usingDates ? "" : value.year} onChange={(v) => onChange({ ...value, year: v, start: "", end: "" })}
          options={yearOptions()} placeholder="All years" testid={`${testid}-year`} />
      </label>
      <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
        From
        <Input type="date" className="h-11" value={value.start || ""} onChange={(e) => set("start", e.target.value)} data-testid={`${testid}-start`} />
      </label>
      <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
        To
        <Input type="date" className="h-11" value={value.end || ""} onChange={(e) => set("end", e.target.value)} data-testid={`${testid}-end`} />
      </label>
      {ctx.isAdmin && (
        <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
          Church
          <NativeSelect value={value.church_id} onChange={(v) => set("church_id", v)} placeholder="All churches"
            options={ctx.churches.filter((c) => !value.region_id || c.region_id === value.region_id).map((c) => ({ value: c.id, label: c.name }))} testid={`${testid}-church`} />
        </label>
      )}
      {ctx.isAdmin && ctx.feat("region_filter") && ctx.regions.length > 0 && (
        <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
          Region
          <NativeSelect value={value.region_id} onChange={(v) => onChange({ ...value, region_id: v, church_id: "" })} placeholder="All regions"
            options={ctx.regions.map((r) => ({ value: r.id, label: r.name }))} testid={`${testid}-region`} />
        </label>
      )}
      {extra.filter((f) => !f.when || f.when(ctx)).map((f) => (
        <label key={f.key} className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
          {f.label}
          <NativeSelect value={value[f.key]} onChange={(v) => set(f.key, v)} placeholder="All" options={f.options(ctx)} testid={`${testid}-${f.key}`} />
        </label>
      ))}
      <div className="flex items-end">
        <Button variant="outline" className="h-11 w-full" onClick={() => onChange(defaultFilters())} data-testid={`${testid}-reset`}>
          <RotateCcw className="mr-2 h-4 w-4" /> This year
        </Button>
      </div>
    </div>
  );
}

export const cleanParams = (f) => Object.fromEntries(Object.entries(f).filter(([, v]) => v));
